import { helpers } from './theme/helpers.js';
import { sliders } from './theme/components/sliders.js';
import { headerMenu } from './theme/components/header-menu.js';
import { calendar } from './theme/components/calendar.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	init: function () {
		var self = this;

		sliders.init();
		calendar.init();

		var lightbox = new SimpleLightbox( '.block-gallery ul a' );
		var lightbox2 = new SimpleLightbox( '.block-cards__images a' );
	},
};

jQuery(document).ready(function ($) {
	theme.init();
	headerMenu.init();
});